<template>
  <h1>Ticket</h1>
</template>

<script>
export default {
  name: 'Ticket'
}
</script>